<script>
  export let title = 'Ajax27 Development';
</script>

<div class="main-title">
  <h2>{title}</h2>
</div>
